// src/plugins/gtm.js
import { createGtm } from '@gtm-support/vue-gtm';
import { logInfo, logDebug } from '@/utils/logHelper';

const GTM_ID = process.env.VUE_APP_GTM_ID;
const IS_DEV = process.env.NODE_ENV === 'development';

/**
 * GTM 플러그인 생성
 * @param {Router} router - Vue Router 인스턴스
 */
export function createGtmPlugin(router) {
  if (!GTM_ID) {
    if (IS_DEV) {
      logInfo('[GTM] VUE_APP_GTM_ID 환경변수가 설정되지 않음 - GTM 비활성화');
    }
    return null;
  }

  return createGtm({
    id: GTM_ID,
    dataLayerName: 'dataLayer',
    enabled: true,
    debug: process.env.VUE_APP_GTM_DEBUG === 'true',
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false,
  });
}

export default createGtmPlugin;